import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const pickStoreBtnSx:SxProps = {
    maxWidth: '100%', 
    marginRight:1,
    px: globalBreak({mobile:2,desktop:3}),
    py: globalBreak({mobile:'4px',desktop:0.5}), 
    paddintTop: '8px',
    fontSize: '16px !important',
    textAlign:globalBreak({mobile:'center'}),
    fontFamily:'mikado-regular'
}

export const pickStoreLinkSx:SxProps = {
    cursor: 'pointer',
    textDecoration: 'underline',
    width:  'fit-content',
}

export const storeStockAvailabilitySX:SxProps = {
    flexDirection:"row",
    alignItems:"center",
    columnGap:0.5,
    minWidth: '60%'
}

export const StoreDetailSX:SxProps = {
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'space-between',
    py:3,
    columnGap:1,
    borderBottom: '1.5px solid black', 
    paddingLeft:5
}

export const changeStoreLinkSx:SxProps = {
    textDecoration:'underline',
    cursor:'pointer',
    pb:1,
    fontFamily:'mikado-regular,effra,chaloops-bold !important',
    fontWeight:'bold !important'
}